
























































import Vue from "vue";
import Component from "vue-class-component";
import { CustomDialogOptions, CustomDialogOptionsButton } from "../../types";
import BarChart from "./BarChart.vue";

@Component({
  components: {
    BarChart
  }
})
export default class Dialog extends Vue {
  showDialog = false;
  options = {
    title: "",
    format: "",
    message: "",
    tableHead: {
      name: "",
      value: ""
    },
    table: [
      {
        name: "",
        value: ""
      }
    ],
    buttons: [
      {
        name: "Close",
        color: "indigo",
        callback: undefined
      }
    ]
  } as CustomDialogOptions;

  hide() {
    this.showDialog = false;
  }
  show(options: CustomDialogOptions) {
    this.showDialog = true;
    this.options = options;
    if (
      !this.options.buttons ||
      (this.options.buttons && this.options.buttons.length === 0)
    ) {
      this.options.buttons = [
        {
          name: "Close",
          color: "indigo",
          callback: undefined
        }
      ];
    }
  }
  close(btn?: CustomDialogOptionsButton) {
    this.showDialog = false;
    if (btn && btn.callback) {
      btn.callback();
    }
  }
}
